import { render, staticRenderFns } from "./sidebar-banner.vue?vue&type=template&id=622fdfeb&scoped=true&"
import script from "./sidebar-banner.vue?vue&type=script&lang=js&"
export * from "./sidebar-banner.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-banner.vue?vue&type=style&index=0&id=622fdfeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fdfeb",
  null
  
)

export default component.exports